import { AccordionContent, AccordionItem, AccordionTrigger } from "@/components/atoms/Accordion";
import NumericBadge from "@/components/atoms/NumericBadge";
import Tooltip from "@/components/atoms/Tooltip";

type Props = {
  id: string;
  title: string;
  children: React.ReactNode;
  tooltip: React.ReactNode | string;
  filterCount?: number;
};

const FilterSectionItem = ({ id, title, filterCount = 0, tooltip, children }: Props) => {
  return (
    <AccordionItem value={id}>
      <AccordionTrigger variant={"filter"}>
        <span className={"flex gap-2"}>
          {title}
          <Tooltip symbol={"info"} as={"div"}>
            {tooltip}
          </Tooltip>
          <NumericBadge value={filterCount} color={"blue"} />
        </span>
      </AccordionTrigger>
      <AccordionContent forceMount className={"group-data-[state=closed]:hidden"}>
        <div className={"grid gap-3 pb-2"}>{children}</div>
      </AccordionContent>
    </AccordionItem>
  );
};

export default FilterSectionItem;
